// extracted by mini-css-extract-plugin
module.exports = {"acceptTerms":"styles_acceptTerms__GanMq","fieldWrapper":"styles_fieldWrapper__HZRqr","acceptText":"styles_acceptText__Sl6KQ"};